import type { ColumnsType } from 'antd/es/table';
import type { MeetingAttendeeData } from '../types';

import { TFunction } from 'i18next';
import { Flex, Typography } from 'antd';

import withLoadingSkeleton from '@/HOCs/withLoadingSkeleton';
import themeToken from '@lib/theme/tokens/index';
import { formatNumber } from '@/utils/formatNumber';
import { MeetingStatus } from './enums';

export const meetingAttendeesColumns = (
  meetingStatus: MeetingStatus | undefined,
  isLoading: boolean,
  t: TFunction<'investorRelations', 'meetings'>,
): ColumnsType<MeetingAttendeeData | Record<string, number>> => [
  {
    title: t('attendeeName'),
    dataIndex: 'company_user',
    render: withLoadingSkeleton(isLoading, (val: MeetingAttendeeData['company_user']) => val?.name),
    sorter: true,
  },
  {
    title: t('seenNotice'),
    dataIndex: 'has_attended',
    sorter: true,
    hidden: true,
    render: withLoadingSkeleton(isLoading, (val: boolean) =>
      val ? (
        <Typography.Text
          style={{
            color: themeToken.colorSuccessText,
          }}
        >
          {t('yes')}
        </Typography.Text>
      ) : (
        <Typography.Text
          style={{
            color: themeToken['branding-red-primary-6'],
          }}
        >
          {t('no')}
        </Typography.Text>
      ),
    ),
  },
  {
    title: t('ownership'),
    dataIndex: 'ownership',
    sorter: true,
    render: withLoadingSkeleton(isLoading, (val: MeetingAttendeeData['ownership']) => val ?? '-'),
  },
  {
    title: t('totalShares'),
    dataIndex: 'total_shares',
    sorter: true,
    render: withLoadingSkeleton(isLoading, (val: MeetingAttendeeData['total_shares']) => formatNumber(val) ?? '-'),
  },
  {
    title: t('attendance'),
    dataIndex: 'has_attended',
    hidden: meetingStatus === MeetingStatus.DRAFTED,
    render: withLoadingSkeleton(isLoading, (val: MeetingAttendeeData['has_attended']) => {
      return (
        <Flex justify="space-between">
          <Typography.Text>{val ? t('attended') : t('notAttended')}</Typography.Text>
        </Flex>
      );
    }),
  },
];
